/*
Dilip 02/02/2023 3031450488 addded download functionality for data manager Execution History
Phanee 08/03/2023 3031450488 Fixed dashboard data disable issue
*/
import React, {useState, useContext} from 'react';
import LandingPage from '../../../LandingPage';
import SearchDmExecutionHistory from '../DmExecutionHistory/SearchDmExecutionHistory/index';
import {ThemeContext} from '../../../../themes/ThemeProvider';
function DmExecution({type}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [value, setValue] = useState(0);

  const tabLabels = type === 'Export' ? ['Export Execution History'] : ['Import Execution History'];
  return (
    <>
      <LandingPage
        title={'Data Management'}
        showTabs={true}
        tabValue={0}
        handleTabChange={()=>{}}
        allAntTabs={tabLabels}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {value === 0 && <SearchDmExecutionHistory setValue={setValue} type={type} />}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
}

export default DmExecution;
